export const FemaleIcon = ({ size = 16, color = "#FE964A" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.154 12.3168C10.1416 12.147 10.1334 11.977 10.1292 11.8068C11.9347 11.6219 13.2019 11.1891 13.2019 10.6841C13.197 10.6841 13.1977 10.6628 13.1977 10.655C11.8476 9.43812 14.3679 0.795038 9.67657 0.969288C9.22987 0.633768 8.67884 0.467155 8.12107 0.498955H8.12674C1.77228 0.979205 4.58224 9.14275 3.13369 10.6834H3.13086C3.13653 11.1778 4.36053 11.6028 6.11365 11.7926C6.10869 11.913 6.09807 12.0625 6.0754 12.3125C5.34794 14.2746 0.435651 13.725 0.208984 17.4997H16.0006C15.7746 13.7242 10.8822 14.2739 10.154 12.3168Z"
        fill={color}
      />
    </svg>
  );
};
